import { render } from "./FundsDetailsLiveAccount.vue?vue&type=template&id=ba35a242&scoped=true"
import script from "./FundsDetailsLiveAccount.vue?vue&type=script&lang=js"
export * from "./FundsDetailsLiveAccount.vue?vue&type=script&lang=js"

import "./FundsDetailsLiveAccount.vue?vue&type=style&index=0&id=ba35a242&lang=less&scoped=true"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba35a242"]])

export default __exports__